module.exports = __webpack_public_path__ + "img/gfx2.b6653f2f.svg";